
export const mobileText = {
    fontSize: {
        xs: "0.7rem",
        sm: "0.80rem",
        md: "0.80rem",
        lg: "0.80rem",
        xl: "0.80rem",
    },
}

export const mobilePadding = {
    Padding: "2px"
};
